require('./custom-event');
require('./remove');
require('./isNumber');
require('./array-find');
require('./object-assign');
require('./classList');
require('./performance.now()-polyfill');
require('whatwg-fetch');
require('./closest');
require('./includes');
require('./nodelist-foreach')
require('./matchmedia-matches')
import Promise from '@babel/polyfill';
if (!window.Promise) {
    window.Promise = Promise;
}
